<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="MQ信息回放">
            <!--            <a-button slot="extra" type="primary" @click="handleNewUser">新建用户</a-button>-->
            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="领域(domain)">
                    <a-select v-model="searchP.domain" placeholder="请选择领域" style="width:120px;">
                        <a-select-option v-for="(value, key) in domainMap" :key="key" :value="key">
                            {{ value }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="主题(topic)">
                    <a-input v-model="searchP.topic" placeholder="请输入主题(topic)"></a-input>
                </a-form-item>
                <a-form-item label="标签(Tag)">
                    <a-input v-model="searchP.serviceName" placeholder="请输入标签(serviceName)"></a-input>
                </a-form-item>
                <a-form-item label="关键词">
                    <a-input v-model="searchP.searchKey" placeholder="请输入关键词"></a-input>
                </a-form-item>
                <a-form-item label="回溯消费组名称">
                    <a-input v-model="searchP.consumerGroup" placeholder="回溯消费组名称"></a-input>
                </a-form-item>
                <a-form-item label="开始时间">
                    <a-date-picker v-model="searchP.beginTime" :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
                                   format="YYYY-MM-DD HH:mm:ss" placeholder="选择开始时间"/>
                </a-form-item>
                <a-form-item label="结束时间">
                    <a-date-picker v-model="searchP.endTime" :show-time="{ format: 'YYYY-MM-DD HH:mm:ss' }"
                                   format="YYYY-MM-DD HH:mm:ss" placeholder="选择结束时间"/>
                </a-form-item>
                <a-form-item label="获取数据量">
                    <a-input v-model="searchP.maxNum" placeholder="获取数据量"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key" @click="searchMqInfo">搜索1
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key" @click="searchMqInfoCount">查看总数
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key" @click="searchMqInfoCount">消息@回放
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key"
                              @click="searchMqInfoAndResendMessage">回放消息
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 消息列表 -->
        <a-table :columns="columns" :data-source="msgData" :pagination="false" :loading="tLoading"
                 rowKey="id">
            <!-- 报文 -->
            <template slot="readParams" slot-scope="text,record">
                <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParams(record)"/>
            </template>


        </a-table>
        <a-modal v-model="modalVisible" title="消息报文" @ok="handleOk">
            <json-viewer
                :value="currentRequest"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
        </a-modal>
        <a-modal v-model="confirmVisible" title="Basic Modal" @ok="handleConfirmOk">
            {{ confirmMsg }}
        </a-modal>
    </div>
</template>
<script>

import JsonViewer from "vue-json-viewer"

const columns = [
    {
        title: "序号",
        width: 100,
        align: "center",
        customRender: (text, record, index) => {
            return index + 1;
        }
    },
    {
        title: '主题',
        dataIndex: 'topic',
        align: 'left',
        width: 200,
    },
    {
        title: '消息ID',
        dataIndex: 'msgId',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '标签',
        dataIndex: 'serviceName',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '发生时间',
        dataIndex: 'bornTime',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '发生Host',
        dataIndex: 'bornHostString',
        align: 'center',
        width: 120,
        ellipsises: true
    },

    {
        title: "消息报文",
        width: 120,
        scopedSlots: {customRender: 'readParams'},
        align: "center",
        ellipsis: true,
    },
    // ,
    // {
    //     title: '消息体',
    //     dataIndex: 'body',
    //     align: 'center',
    //     width: 120,
    //     ellipsises: true
    // }
];
const msgData = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            msgData,
            columns,
            searchP: {
                topic: '',
                domain:'',
                serviceName: '',
                consumerGroup: '',
                endTime: '',
                beginTime: '',
                maxNum: 100,
                total: 0,
                pageSize: 0,
                page: undefined,
            },
            tLoading: false,
            currentRequest: "",
            currentResponse: "",
            modalVisible: false,
            confirmVisible: false,
            confirmMsg: "",
            domainMap:{
            },
        };
    },
    methods: {
        handleOk() {
            this.modalVisible = false;
        },

        handleParams(item) {
            this.modalVisible = true;
            try {
                this.currentRequest = JSON.parse(item.body);
            } catch (error) {
                this.currentRequest = item.body;
            }

        },

        handleConfirmOk() {
            this.searchMqInfoAndResendMessage();
            this.confirmVisible = false;
        },
        searchMqInfoAndResendMessage() {
            let c_params = {
                ...this.searchP,
                urlparams: false,
            }
            c_params.endTime = this.searchP.endTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.endTime)) : '';
            c_params.beginTime = this.searchP.beginTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.beginTime)) : '';
            this.$store.dispatch({
                type: "mqinfo/searchMqInfoAndResendMessage",
                params: c_params
            }).then((res) => {
                this.tLoading = true;
                console.log(res);
                if (res.data.data) {
                    this.msgData = res.data.data.list;
                    this.searchP.total = this.msgData.length;
                    this.message.success("【" + res.data.data.total + "】条消息回放成功!")
                } else {
                    this.msgData = []
                    this.searchP.total = 0
                }
                this.columns = this.columns.filter(function (n) {
                    return n.dataIndex != "ResendStatus"
                })
                this.columns.push(
                    {
                        title: '回溯状态',
                        dataIndex: 'ResendStatus',
                        align: 'center',
                        width: 120,
                        ellipsises: true
                    }
                )
                this.tLoading = false;
                // this.searchP.total = result.totalRecords;
                // this.searchP.pageSize = result.pageSize;
                // this.searchP.page = result.page;
            })
        },
        searchMqInfo() {
            let c_params = {
                ...this.searchP,
                timeout:30000,
                urlparams: false,
            }
            c_params.endTime = this.searchP.endTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.endTime)) : '';
            c_params.beginTime = this.searchP.beginTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.beginTime)) : '';
            this.$store.dispatch({
                type: "mqinfo/searchMqInfo",
                params: c_params
            }).then((res) => {
                this.tLoading = true;
                console.log(res);
                if (res.data.data) {
                    this.msgData = res.data.data;
                    this.searchP.total = this.msgData.length;
                } else {
                    this.msgData = []
                    this.searchP.total = 0
                }
                this.columns = this.columns.filter(function (n) {
                    return n.dataIndex != "ResendStatus"
                })
                this.tLoading = false;
                // this.searchP.pageSize = this.msgData.pageSize;
                // this.searchP.page = this.msgData.page;
            })
        }, searchMqInfoCount() {
            let c_params = {
                ...this.searchP,
                urlparams: false,
            }
            c_params.endTime = this.searchP.endTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.endTime)) : '';
            c_params.beginTime = this.searchP.beginTime ? this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date(this.searchP.beginTime)) : '';
            this.$store.dispatch({
                type: "mqinfo/searchMqInfoCount",
                params: c_params
            }).then((res) => {
                this.tLoading = true;
                console.log(res);
                if (res.data.data && res.data.data.total && res.data.data.total > 0) {
                    // message.success(res.data)
                    this.confirmMsg = "是否确认回放【" + res.data.data.total + "】条消息?";
                    this.confirmVisible = true;
                }
                this.tLoading = false;
                // this.searchP.pageSize = this.msgData.pageSize;
                // this.searchP.page = this.msgData.page;
            })
        },
        handlePageChange(c_p) {
            this.searchP.page = c_p;
            this.updateRoute();
        }
        ,
        updateRoute() {
            this.$router.push({
                query: {
                    topic: this.searchP.topic,
                    serviceName: this.searchP.serviceName,
                    searchKey: this.searchP.searchKey,
                    consumerGroup: this.searchP.consumerGroup,
                    beginTime: this.searchP.beginTime,
                    endTime: this.searchP.endTime,
                    maxNum: this.searchP.maxNum,

                }
            });
        }
        ,
        handleSearchReset() {
            this.searchP.page = 1;
            this.searchP.topic = '';
            this.searchP.serviceName = '';
            this.searchP.searchKey = '';
            this.searchP.consumerGroup = '';
            this.searchP.beginTime = '';
            this.searchP.endTime = '';
            this.searchP.maxNum = 100;
            this.updateRoute();
        }
        ,
        handleNewUser() {
            this.$router.push({
                path: "addUser",
            });
        }
        ,
        handleSubmit(e) {
            e.preventDefault();
            this.searchP.page = 1
            this.updateRoute()
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        }
        ,
        queryDomainMap(){
            let that = this;
            this.$store.dispatch({
                type: "mqinfo/queryDomainMap",
                params: {},
                timeout: 5000,
            }).then((res) => {
                console.log(res);
                if (res.data.data) {
                    that.domainMap = res.data.data;
                }
            })
        },        
    },

    components: {
        JsonViewer,
    }
    ,
    watch: {
        '$route'() {
            this.$router.go(0);
        }
    }
    ,
    mounted() {
        let query = this.$route.query;
        this.searchP.topic = query.topic ? query.topic : '';
        this.searchP.serviceName = query.serviceName ? query.serviceName : '';
        this.searchP.searchKey = query.searchKey ? query.searchKey : '';
        this.searchP.consumerGroup = query.consumerGroup ? query.consumerGroup : '';
        this.searchP.beginTime = query.beginTime ? query.beginTime : '';
        this.searchP.endTime = query.endTime ? query.endTime : '';
        this.searchP.maxNum = query.maxNum ? query.maxNum : 100;
        this.queryDomainMap();
        // this.getUserList();
    }
}
;
</script>
<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}

td {
    padding: 10px 10px;
}
</style>
